import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Checkbox,
  Container,
  FormControlLabel,
  Grid,
  Typography,
} from '@mui/material';
import usePagination from 'src/hooks/usePagination';
import CustomTable from 'src/components/table/table';
import TabTitle from 'src/components/tabTitle/tabTitle';
import { GET_USER, DELETE_USER } from 'src/apiService/apiDeclaration';
import PageHeader from 'src/components/pageHeader/PageHeader';
import { userTableColumns } from 'src/constants/columnConfig';
import { ICONS } from 'src/assets/library';
import MenuPopover from 'src/components/menu/menu';
import { useModal } from 'src/hooks/useModal';
import { removeEmptyKeys, showErrorTost, showSuccessTost, userStatusArray } from 'src/constants';
import AddUserForm from 'src/components/form/addUserForm';
import LoaderButton from 'src/components/loaderButton/loaderButton';
import { GridExpandMoreIcon } from '@mui/x-data-grid';
import { useState } from 'react';

const UserPage = () => {
  let params = { role: 'ADMIN' };
  const { setDialogData, handleModalClose } = useModal();
  const updatedUserTable = [...userTableColumns];
  const [status, setStatus] = useState([]);
  const { paginationModel, setPaginationModel, loading, data, refresh, setQuerryParams } = usePagination(
    GET_USER,
    params
  );
  const onSuccess = () => {
    handleModalClose();
    refresh();
  };
  const onDelete = async (id) => {
    try {
      await DELETE_USER(id);
      onSuccess();
      showSuccessTost('Admin deleted successfully');
    } catch (error) {
      console.log(error);
      showErrorTost('Error in deleting user');
    }
  };

  const handleLabelClick = (value) => {
    if (status.includes(value)) {
      const updatedArray = status.filter((option) => option !== value);
      setStatus(status.filter((option) => option !== value));
      params.status = updatedArray.join(',');
      setQuerryParams(removeEmptyKeys(params));
    } else {
      const updatedArray = [...status, value];
      setStatus([...status, value]);
      params.status = updatedArray.join(',');
      setQuerryParams(removeEmptyKeys(params));
    }
  };
  updatedUserTable.push({
    field: 'action',
    headerName: 'Action',
    sortable: false,
    disableColumnMenu: true,
    width: 80,
    renderCell: ({ row }) => {
      return (
        <MenuPopover
          menuArray={[
            {
              iconPath: require(`src/assets/trash.png`),
              name: 'Delete user',
              action: () => {
                setDialogData({
                  showModal: true,
                  description: 'Are you sure you want to delete this user?',
                  onConfirm: () => onDelete(row._id),
                });
              },
            },
            {
              icon: ICONS.edit,
              name: 'Edit user',
              action: () => {
                setDialogData({
                  showModal: true,
                  title: 'Edit Admin',
                  child: <AddUserForm onSuccess={() => onSuccess()} data={row} isAdmin={true} />,
                });
              },
            },
          ]}
        />
      );
    },
  });
  return (
    <Container maxWidth="xl">
      <Grid container spacing={2}>
        <TabTitle title={'Admins'} />
        <Grid
          item
          xs={12}
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            flexDirection: {
              sm: 'row',
              xs: 'column',
            },
            gap: 4,
          }}
        >
          <PageHeader xs={12} md={4} pageTitle={'Admins'} />
          <Grid
            item
            xs={12}
            sm={8}
            sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end', alignItems: 'flex-end' }}
          >
            <Grid item xs={6} md={2.5}>
              <Accordion>
                <AccordionSummary
                  sx={{
                    backgroundColor: '#2065d1',
                    minHeight: '36px',
                    maxHeight: '24px',
                    borderRadius: 1,
                  }}
                  expandIcon={<GridExpandMoreIcon sx={{ color: 'white' }} />}
                >
                  <Typography color={'white'} fontWeight={600}>
                    Filter {status.length > 0 && '(x' + status.length + ')'}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  {userStatusArray.slice(1).map(({ label, value }, index) => (
                    <Grid key={index} item xs={12}>
                      <FormControlLabel
                        control={<Checkbox size="small" onClick={() => handleLabelClick(value)} />}
                        label={label}
                      />
                    </Grid>
                  ))}
                </AccordionDetails>
              </Accordion>
            </Grid>
            <LoaderButton
              buttonText={'Add Admin'}
              sx={{ minHeight: '36px' }}
              onClick={() =>
                setDialogData({
                  showModal: true,
                  title: 'Add new admin',
                  child: <AddUserForm onSuccess={() => onSuccess()} isAdmin={true} />,
                })
              }
            />
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <CustomTable
            loading={loading}
            isServerSidePagination
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            columns={updatedUserTable}
            rows={data.rows}
            rowCount={data.rowCount}
            isRowColored={false}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default UserPage;
